<template>
    <div class="tw:border tw:border-slate-200 tw:rounded-2xl tw:overflow-hidden tw:mb-4 tw:bg-white tw:shadow-sm">
        <div @click="isOpen = !isOpen" class="tw:flex tw:items-stretch tw:cursor-pointer tw:hover:bg-slate-50 tw:transition-colors">
            <div class="tw:w-28 tw:md:w-40 tw:shrink-0 tw:flex tw:items-center tw:justify-center  tw:overflow-hidden">
                <img
                    v-if="pedido.evento?.evento_imagen"
                    :src="pedido.evento.evento_imagen"
                    class="tw:w-full tw:h-full tw:object-cover"
                    :alt="pedido.evento?.name"
                />
                <div v-else class="tw:w-full tw:h-full tw:flex tw:items-center tw:justify-center" :style="colorScheme.bgStyle">
                    <i class="material-icons tw:text-3xl" :style="`color: ${colorScheme.iconColor}`">confirmation_number</i>
                </div>
            </div>

            <div class="tw:flex-1 tw:p-4 tw:flex tw:items-center tw:justify-between tw:gap-4">
                <div>
                    <h2 class="tw:text-base tw:font-bold tw:text-slate-900 tw:uppercase tw:tracking-tight tw:m-0">{{ pedido.evento?.name }}</h2>
                    <div class="tw:flex tw:flex-wrap tw:items-center tw:gap-x-4 tw:gap-y-1 tw:mt-1">
                        <p v-if="pedido.sesion" class="tw:text-slate-500 tw:text-xs tw:flex tw:items-center tw:gap-1 tw:m-0">
                            <i class="material-icons tw:text-sm">calendar_month</i>
                            {{ pedido.sesion.fecha }}
                        </p>
                        <p class="tw:text-xs tw:font-mono tw:font-bold tw:text-primary tw:px-2 tw:py-0.5 tw:bg-red-50 tw:rounded tw:m-0">
                            #{{ pedido.id }}
                        </p>
                        <p class="tw:text-xs tw:text-slate-400 tw:m-0">{{ pedido.entradas?.length || 0 }} {{ (pedido.entradas?.length || 0) === 1 ? $t('perfil.entrada') : $t('perfil.entradas') }}</p>
                    </div>
                </div>
                <i class="material-icons tw:text-slate-400 tw:transition-transform tw:duration-300" :class="{ 'tw:rotate-180': isOpen }">expand_more</i>
            </div>
        </div>

        <transition name="fade">
            <div v-if="isOpen" class="tw:border-t tw:border-slate-100">
                <div class="tw:p-4 tw:flex tw:flex-wrap tw:gap-3 tw:border-b tw:border-slate-100">
                    <Button variant="alt" v-if="!todasAnuladas" as="a" :href="pedido.url_pdf" target="_blank" rel="noopener">
                        <i class="material-icons tw:text-sm">download</i> {{ $t('perfil.descargar_todas') }}
                    </Button>
                </div>

                <div class="tw:p-4 tw:space-y-3">
                    <p class="tw:text-xs tw:font-bold tw:text-slate-400 tw:uppercase tw:tracking-widest tw:flex tw:items-center tw:gap-2 tw:m-0 tw:pb-3">
                        <i class="material-icons tw:text-sm">local_activity</i> {{ $t('perfil.tickets_invitacion') }}
                    </p>
                    <InvitacionEntradaRow
                        v-for="(entrada, i) in pedido.entradas || []"
                        :key="`${entrada.id}-${i}`"
                        :entrada="entrada"
                        :pedido="pedido"
                        @edit-success="emit('edit-success')"
                    />
                </div>
            </div>
        </transition>
    </div>
</template>

<script setup>
    import { ref, computed } from 'vue';
    import { randomColor } from '@/utils/randomColor';
    import InvitacionEntradaRow from './InvitacionEntradaRow.vue';
    import Button from '@/modules/front/ui/Button.vue';

    const props = defineProps({
        pedido: { type: Object, required: true },
    });

    const isOpen = ref(false);
    const emit = defineEmits(['edit-success']);
    const colorScheme = computed(() => randomColor(props.pedido.id));
    const todasAnuladas = computed(() => props.pedido.entradas?.every(e => !!e.deleted_at) ?? false);
</script>
